import { Box, ButtonBase, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {
	couponBannerSX,
	couponBodySX,
	couponCodeButtonSX,
	couponCodeSX,
	couponCopyIconSX,
	couponEyebrowSX,
	couponExpiryIconSX,
	couponExpirySX,
	couponInfoIconSX,
	couponInfoSX,
	couponLabelGroupSX,
	couponLabelSX,
	couponLoginIconSX,
	couponLoginRowSX,
	couponLoginTextSX,
	couponTopRowSX,
} from '@/components/blocks/EmailRecommendedCouponPopup/styles';

interface CouponBannerProps {
	code: string;
	label: string;
	expiry: string;
	isLoggedIn: boolean;
	loginMessage: string;
}

export const CouponBanner = ({
	code,
	label,
	expiry,
	isLoggedIn,
	loginMessage,
}: CouponBannerProps) => {
	const handleOnCopy = () => {
		navigator.clipboard.writeText(code);
	};

	return (
		<Box sx={couponBannerSX}>
			{!isLoggedIn ? (
				<Box sx={couponLoginRowSX}>
					<LockOutlinedIcon sx={couponLoginIconSX} />
					<Typography sx={couponLoginTextSX}>{loginMessage}</Typography>
				</Box>
			) : null}

			<Box sx={couponBodySX}>
				<Box sx={couponTopRowSX}>
					<Box sx={couponLabelGroupSX}>
						<Typography sx={couponEyebrowSX}>{'Tu cupón personal'}</Typography>
						<Typography component="h3" sx={couponLabelSX}>
							{label}
						</Typography>
					</Box>
					<ButtonBase sx={couponCodeButtonSX} onClick={handleOnCopy} aria-label="Copiar cupón">
						<Typography sx={couponCodeSX}>{code}</Typography>
						<ContentCopyIcon sx={couponCopyIconSX} />
					</ButtonBase>
				</Box>

				<Box sx={couponExpirySX}>
					<AccessTimeIcon sx={couponExpiryIconSX} />
					<Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}>
						{expiry}
					</Typography>
				</Box>

				<Typography sx={couponInfoSX}>
					<InfoOutlinedIcon sx={couponInfoIconSX} />
					{'Tu descuento se activa automáticamente al entrar a tu cuenta.'}
				</Typography>
			</Box>
		</Box>
	);
};
